import Photo from '@rails/upload/React/Photo';

import { UploadFile } from '@rails/upload';

const MyUploads = () => {
  return (
    <div className='flex flex-col'>
      <Photo
        mode='send'
        limit={400}
      />
      <UploadFile multiple />
    </div>
  );
};

export default MyUploads;
